import {defineNuxtPlugin} from '#imports';
import {focusInput} from '~/directives/focusInput';
import {scrollable} from '~/directives/scrollable';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('focusInput', focusInput);
    nuxtApp.vueApp.directive('scrollable', scrollable);
});
